const customJavascript = `{
  "custom_js": "window.scrollTo(0,document.body.scrollHeight);"
}`;

export default customJavascript;
